import { Controller } from "@hotwired/stimulus"

// Live preview swatch next to an icon-name <select> (e.g. the nav item/group
// icon picker) — mirrors the selected option onto a sibling <i> glyph.
// Listens for the native `change` choices.js dispatches on the underlying
// <select> rather than declaring a Stimulus target on it directly, since
// that element lives inside UI::SelectComponent's own choices-controller
// wrapper markup.
export default class extends Controller {
  static targets = ["preview"]

  update(event) {
    if (event.target.tagName !== "SELECT") return

    const name = event.target.value
    this.previewTarget.className = name ? `ti ti-${name} text-2xl text-neutral-600` : "ti text-2xl text-neutral-300"
  }
}
